import Axios, { AxiosRequestConfig } from 'axios';

import { getTicketUid } from '@core/utils';
import { SendSms, SendSmsOption, SendSmsOptions } from './model';

const ATR_FRAMEWORK_API_ENDPOINT = `${location.origin}/atr-framework-services/api/`;

const atrFrameworkApi = {
	sendSms: (options: SendSmsOptions) => {
		const ticketUID = getTicketUid();

		return new Promise<SendSms>((resolve, reject) => {
			const formData = new FormData();
			const phoneNumber = options.PhoneNumber.replace(/[ ,\(,\),-]/gi, '');

			formData.append(SendSmsOption.Message, encodeURIComponent(options.Message));
			formData.append(SendSmsOption.PhoneNumber, encodeURIComponent(phoneNumber));

			const request: AxiosRequestConfig = {
				data: formData,
				headers: {
					ticketuid: ticketUID,
				},
				method: 'post',
				url: `${ATR_FRAMEWORK_API_ENDPOINT}v2/notifications/sms`,
			};

			Axios(request)
				.then(response => resolve(response.data as SendSms))
				.catch(reject);
		});
	},
};

export { atrFrameworkApi };
